// Which order a ticket's case is for (Trac #1057).

const PLATFORM_BY_CHANNEL = { ebay: 'eBay', reverb: 'Reverb' }

// A stable key for an order in the picker. Shopify orders carry shopifyId.
export function orderKey(order) {
  return String(order.shopifyId || order.id)
}

// The order a case opens against when nobody has chosen one: the platform's
// own order for eBay and Reverb tickets, otherwise the newest order.
export function defaultCaseOrder(orders, channel) {
  if (!orders?.length) return null
  const platform = PLATFORM_BY_CHANNEL[channel]
  if (platform) return orders.find(o => o.platform === platform) || null
  return orders[0]
}

// The chosen order if it is still in the customer's history, else the default.
export function resolveCaseOrder(orders, channel, chosenKey) {
  const chosen = chosenKey && orders?.find(o => orderKey(o) === chosenKey)
  return chosen || defaultCaseOrder(orders, channel)
}

// Title and type of the product the case is about: the first ticked line,
// else the order's first line.
export function caseProduct(order, tickedLines) {
  const first = tickedLines[0]
  if (first) {
    const orderLine = order?.line_items?.find(l => l.title === first.title)
    return { title: first.title || null, type: first.product_type || orderLine?.product_type || null }
  }
  const firstLine = order?.line_items?.[0]
  return { title: firstLine?.title || null, type: firstLine?.product_type || null }
}
